import React from 'react'

const DandruffTreatmentBenefits = () => {
  return (
    <div className="hairSubServiceWhat">
    <h3>Benefits of SCENT’s Dandruff Treatment in Bangalore</h3>
    <li>
      <h6>Immediate Relief:</h6>
      <p>
        Noticeable reduction in itching and flaking after just one session.
      </p>
    </li>
    <li>
      <h6>Long-Term Results: </h6>
      <p>
        Our holistic approach addresses the root causes, ensuring lasting
        relief from dandruff.
      </p>
    </li>
    <li>
      <h6> Improved Scalp Health:</h6>
      <p>
         Treatments not only tackle dandruff but also
        enhance overall scalp and hair health.
      </p>
    </li>
    <li>
      <h6> Boosted Confidence:</h6>
      <p>
         Enjoy flake-free hair and restored confidence
        in your appearance.
      </p>
    </li>
  </div>
  )
}

export default DandruffTreatmentBenefits
